<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="col-md-6" *ngIf="showMemberDropdown">
  <lib-members-selector [bindReviewer]="true" [visitKey]="visitMetaData.visitKey" [sessionId]="sessionId"
    (selectionChange)="memberChanged($event.value)" [(ngModel)]="selectedMember"></lib-members-selector>
</div>

<!-- <ng-container *ngIf="evaluatedSummaryType == 'AllSummary'">
  <ng-container [ngTemplateOutlet]="executiveSummaryContent"
    [ngTemplateOutletContext]="{ $implicit: evaluatedSummaryType }"></ng-container>
</ng-container> -->

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="distribute-tree mt-3">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle [class.active]="selectedNode?.id === node.id">
    <ng-container [ngTemplateOutlet]="treeNode"
      [ngTemplateOutletContext]="{ $implicit: node, class: 'px-3' }"></ng-container>
  </mat-tree-node>

  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <div class="mat-tree-node" [class.active]="selectedNode?.id === node.id">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.criterionEnglishName">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <ng-container [ngTemplateOutlet]="treeNode"
        [ngTemplateOutletContext]="{ $implicit: node, class: '' }"></ng-container>
    </div>

    <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>

<ng-template #treeNode let-node let-class="class">
  <div (click)="rowClicked(node)" class="distribute-tree__node {{class}}" role="button">
    <span class="d-inline-block rounded-circle" [ngClass]="{'evaluated':node.evaluate,'pending':!node.evaluate}"></span>
    <span
      class="d-inline-block font-weight-bold mx-1 px-2 py-1 chip {{node.hasError ? 'error' : ''}}">{{node.criterionKey}}</span>
    {{
    node
    | propertyLocalized : ["criterionArabicName", "criterionEnglishName"]
    | async
    }}
  </div>
</ng-template>

<div class="row" *ngIf="selectedNode">
  <app-masar-criterion-preview class="col-md-6"></app-masar-criterion-preview>
  <app-masar-criterion-decision class="col-md-6"></app-masar-criterion-decision>
</div>

<ng-container *ngIf="executeVisitType != 'SessionDetails' && !!dataSource?.data">

  <ng-container *ngIf="evaluatedSummaryType == 'All'">
    <ng-container [ngTemplateOutlet]="executiveSummaryContent"
      [ngTemplateOutletContext]="{ $implicit: evaluatedSummaryType }"></ng-container>
  </ng-container>

  <br/>
  <app-masar-decision-summary *ngFor="let item of summaries" [criterionKeys]="mainCriterionKeys" [title]="item.label"
    [type]="item.type" [filter]="item.filter"
    [allowedSummaryType]="['All','AllSummary']"></app-masar-decision-summary>
</ng-container>



<ng-template #executiveSummaryContent let-item>
  <form #executiveSummaryForm="ngForm">
    <br />
    <mat-label class="font-weight-bold field-required">{{ 'forms.common.Criteria.executiveSummary' | translate }}
    </mat-label>

    <p-editor *ngIf="enabledExecutiveSummary;else disableExecutiveSummary" [style]="{'height':'200px'}" 
    [(ngModel)]="executiveSummaryHTML" maxlength="2000" required
      [readonly]="false" (onTextChange)="onExecutiveSummaryChange($event)"
      [modules]="quillModules" [ngModelOptions]="{standalone: true}">
      <ng-template pTemplate="header">
        <span class="ql-formats">
        </span>
      </ng-template>
    </p-editor>

    <ng-template #disableExecutiveSummary>
      <p-editor [style]="{'height':'200px'}" [(ngModel)]="executiveSummaryHTML" maxlength="2000" required
        [readonly]="true" (onTextChange)="onExecutiveSummaryChange($event)"
        [ngModelOptions]="{standalone: true}">
        <ng-template pTemplate="header">
          <span class="ql-formats">
          </span>
        </ng-template>
      </p-editor>
    </ng-template>
    <div align="end">
      <mat-hint>{{executiveSummary?.length}} / 2000</mat-hint>
    </div>
    <br />

    <div class="d-flex justify-content-end" *ngIf="enabledExecutiveSummary">
      <button class="mt-3" mat-flat-button (click)="saveExecutiveSummary()" color="primary"
        [disabled]="!executiveSummaryForm.form.valid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-container *ngIf="!hideMistake && executeVisitType != 'SessionDetails' && decisionInputs$ | async as decisionInput">
  <label class="d-block mt-2 field-required">{{'forms.common.isThereNotes' | translate}}</label>
  <mat-radio-group (change)="updateResultData()" [(ngModel)]="notesDecision" [disabled]="isMistakeDisabled">
    <mat-radio-button class="w-min-100" [value]="true">{{'forms.common.true' | translate}}</mat-radio-button>
    <mat-radio-button class="w-min-100" [value]="false">{{'forms.common.false' | translate}}</mat-radio-button>
  </mat-radio-group>

  <div *ngIf="notesDecision">
    <app-masar-mistake-list [disabled]="isMistakeDisabled"></app-masar-mistake-list>
  </div>
</ng-container>